import React, { useState } from 'react';
import { signOut } from '../../store/action/auth';
import { isAuthenticated } from '../../store/action/auth';
import { withRouter } from 'react-router-dom';
import { Button } from '../../components/buttons';
import ReactInterval from 'react-interval';
import SearchBar from '../../components/navbars/SearchBar';

const { user } = isAuthenticated();

const Header = (props) => {
    const [loading, setLoading] = useState(false);
    const [bg, setBg] = useState(false);

    return (
        <div className={`flex-column  ${bg ? "search" : null}`}>
            <nav className="flex-column fixed-top">
                <div className='py-2 bg-primary text-white text-center'>
                    <a className='text-white' href="https://dashboard.biteship.com"><b>🎉 Baru! Tampilan baru dashboard Biteship! Klik disini untuk mencoba 🎉 </b></a>
                </div>
                <div className="navbar py-0 fixed-top shadow ">
                    <ReactInterval
                        timeout={2000}
                        enabled={loading}
                        callback={() =>
                            signOut(() => {
                                setLoading(false);
                                props.history.push('/');
                                window.location.reload();
                            })
                        }
                    />
                <a className="navbar-brand" id="header-logo">
                        <img
                            className="h-8 w-8 rounded-full" 
                            style={{height:40}}
                            src={"/images/logos/biteship.png"} 
                            alt=""
                        />
                    </a>
                    <SearchBar onSearchActive={setBg}/>
                    <form className="form-inline">
                        <span className="mr-sm-2">
                            <strong>{user ? user.firstName +' '+ user.lastName : ''}</strong>
                        </span>
                        <Button
                            onClick={() => setLoading(true)}
                            loading={loading}
                            className="btn btn-outline-primary btn-sm my-2 my-sm-0"
                        >
                            {props.loading ? "Signing Out..." : "Sign Out"}
                        </Button>
                    </form>
                </div>
                
            </nav>
        </div>

  );
}

export default withRouter(Header);
